import { Link } from "@tanstack/react-router";

import brandMark from "../assets/brand-mark.png";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      aria-label="SafePlate home"
      className="inline-flex items-center gap-3 text-stone-950 no-underline"
      to="/"
    >
      <img
        alt=""
        className="size-9 rounded-[0.55rem]"
        height={36}
        src={brandMark}
        width={36}
      />
      {compact ? null : (
        <span className="text-[1.05rem] font-black tracking-[-0.035em]">
          SafePlate
        </span>
      )}
    </Link>
  );
}
